// src/xls-icon.tsx
import { createSvgIcon } from "@mui/material";
import { jsx } from "react/jsx-runtime";
var XLSIcon = createSvgIcon(
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.409 3.4h8.05v4.3c0 .2.1.4.201.5.101.1.302.2.504.2H20v-.7c0-.1-.07-.26-.302-.5l-5.132-5-.201-.2H5.409c-.403 0-.805.2-1.006.4C4.2 2.6 4 3 4 3.4v5.1h1.409V3.4Zm9.459 1L17.484 7h-2.616V4.4Zm1.902 6.66h2.314V9.69H16.77c-1.137 0-2.063.73-2.063 1.63v1.45c0 .9.926 1.63 2.063 1.63h1.076c.232 0 .433.12.433.26v2.35c0 .14-.201.26-.433.26h-2.314v1.37h2.314c1.138 0 2.063-.73 2.063-1.63v-2.35c0-.9-.925-1.63-2.063-1.63H16.77c-.232 0-.433-.12-.433-.26v-1.45c0-.14.201-.26.433-.26ZM6.677 15.13 5.61 18.56H4l1.147-4.43L4 9.7h1.66l1.017 3.34h.01L7.733 9.7h1.62l-1.137 4.43 1.137 4.43h-1.62l-1.046-3.43h-.01ZM4.403 20.6c.301.3.603.4 1.006.4H18.49c.402 0 .805-.2 1.006-.4.302-.3.402-.6.402-1H4c0 .4.1.7.403 1Zm6.108-1.95V9.7h1.63v7.56h2.214v1.39H10.51Z"
    }
  ),
  "XLSIcon"
);

export {
  XLSIcon
};
